module.exports = __webpack_public_path__ + "img/product-2.2a4a97e5.jpg";